<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Sill Colour';
                }
            },
            component_id: {
                default(){
                    return 'cill_colour';
                }
            },
            frameColourExternal: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameColourExternal);
            },
            url(){
                return '/api/options/' + this.fabricator + '/sill-colour?frame_colour_external=' + this.frameColourExternal;
            },
            cache_key(){
                return '_' + this.frameColourExternal;
            },
            panel_required(){
                return true;
            }
        },
        watch: {
            'frameColourExternal': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
